import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { environment } from "@env/environment";
import { ApiRoutes } from "app/core/constants/api-routes";
import { lastValueFrom } from "rxjs";
import {
  AvailableDatesResponse,
  OrderReschedulePayload,
  OrderRescheduleResponse,
  ReschedulingHistoryResponse,
} from "../models/order-reschedule.model";

@Injectable({ providedIn: "root" })
export class OrderRescheduleService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.API_RESCHEDULING;

  async fetchAvailableDates(
    tenantId: string,
    orderId: string,
  ): Promise<string[]> {
    const url = `${this.baseUrl}${ApiRoutes.order.rescheduling.availableDates(
      tenantId,
    )}`;

    const params = new HttpParams().set("orderId", orderId);

    const response = await lastValueFrom(
      this.http.get<AvailableDatesResponse>(url, { params }),
    );
    if (response.code === 1) {
      return response.data;
    }

    throw new Error(response.message || "Failed to fetch available dates");
  }

  async fetchReschedulingHistory(
    tenantId: string,
    orderId: string,
  ): Promise<ReschedulingHistoryResponse> {
    const url = `${this.baseUrl}${ApiRoutes.order.rescheduling.history(tenantId, orderId)}`;

    const response = await lastValueFrom(
      this.http.get<ReschedulingHistoryResponse>(url),
    );

    if (response.code === 1) {
      return response;
    }

    throw new Error(response.message || "Failed to fetch rescheduling history");
  }

  async rescheduleOrder(
    payload: OrderReschedulePayload,
  ): Promise<OrderRescheduleResponse> {
    const url = `${this.baseUrl}${ApiRoutes.order.rescheduling.submit(
      payload.tenantId,
    )}`;

    try {
      const response = await lastValueFrom(
        this.http.post<OrderRescheduleResponse>(url, payload),
      );

      return response;
    } catch (error: any) {
      if (error?.status === 500) {
        throw new Error("Server error during order rescheduling");
      }
      throw error;
    }
  }

  
}
